export const services = {
  hero: {
    title: 'Complete Solutions for Your Business',
    subtitle: 'Discover all the tools and services we offer to automate and optimize your business'
  },
  list: [
    {
      title: 'Intelligent Chatbot',
      description: 'AI assistant that responds on WhatsApp, Instagram, and Facebook. Schedules appointments, answers questions, and provides information 24/7 with natural conversations.',
      deliverables: [
        'Multi-channel setup (WhatsApp, Instagram, Facebook)',
        'AI training with your tone and protocols',
        'Integration with your calendar and systems',
        'Automatic responses and smart routing',
        'Analytics and conversation reports',
        'Ongoing support and optimization'
      ]
    },
    {
      title: 'Appointment Management System',
      description: 'Complete platform that optimizes every aspect of your scheduling. From booking to post-appointment follow-up with intelligent automation.',
      deliverables: [
        'Smart calendar with conflict prevention',
        'Online booking system',
        'Automatic reminders (WhatsApp, SMS, email)',
        'Waiting list management',
        'Service packages and recurring appointments',
        'Integration with your existing tools'
      ]
    },
    {
      title: 'Professional Websites',
      description: 'Converting websites with integrated online booking. Optimized design to turn visitors into clients with modern and responsive interface.',
      deliverables: [
        'Custom responsive design',
        'Integrated online booking',
        'SEO optimization',
        'Contact forms and chatbot',
        'Google Analytics integration',
        'Hosting and maintenance included'
      ]
    },
    {
      title: 'Automatic Reminders',
      description: 'Reduce no-shows with intelligent reminder system. Automatic confirmations and follow-ups via multiple channels.',
      deliverables: [
        'Automatic reminders via WhatsApp, SMS, email',
        'Appointment confirmations',
        'Post-appointment follow-ups',
        'Customizable schedules and messages',
        'No-show reports and analytics',
        'Integration with your calendar'
      ]
    },
    {
      title: 'Automation Consulting',
      description: 'We analyze your business and design custom solutions. Complete implementation with training and ongoing support.',
      deliverables: [
        'Business process analysis',
        'Custom automation strategy',
        'Implementation and configuration',
        'Team training',
        'Technical documentation',
        'Ongoing support and optimization'
      ]
    }
  ],
  integrations: {
    title: 'Integrations with Your Tools',
    description: 'Connect VELXIA with your CRM, calendar, and management systems. We work with the tools you already use to create a unified ecosystem.',
    features: [
      'Google Calendar, Outlook, Apple Calendar',
      'WhatsApp Business, Instagram, Facebook',
      'CRM systems (Salesforce, HubSpot, Zoho)',
      'Payment platforms (Stripe, PayPal)',
      'Email marketing (Mailchimp, SendGrid)',
      'Custom integrations via API'
    ]
  }
};
